<nav class="navbar navbar-expand-md navbar-light">
	<a class="title_aet" routerLink="">AET</a>
	<!-- <a class="home" class="navbar-brand" [routerLink]="['/home']" [ngClass]="activeBoard? 'active' : '' ">
		<img src="./assets/images/home-grey.svg" *ngIf="enableHomeGrey" class="homeGrey">
		<img src="./assets/images/home-red.svg" *ngIf="enableHomeRed" class="homeRed"></a> -->


	<button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
		aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
		<span class="navbar-toggler-icon"></span>
	</button>


	<div class="menu-group collapse navbar-collapse" id="navbarSupportedContent">
		<mat-nav-list class="inline toolbar-links">
			<a mat-list-item class="navbar-brand-tool menu pl-3 pr-3" [routerLink]="['/home']" [ngClass]="activeBoard? 'active' : ''">Dashboard</a>
			<!-- <a mat-list-item [routerLink]="['/dashboard']" [ngClass]="highlightDashboard? 'active' : '' " class="menu roboto-bold">Dashboard</a> -->
			<a mat-list-item [routerLink]="['/cpMatrix']" [ngClass]="highlightCPM? 'active' : '' " class="menu roboto-bold">Control Point Matrix</a>
			<a mat-list-item [routerLink]="['/safety-dashboard']" [ngClass]="highlightSafetydash? 'active' : '' " class="menu roboto-bold">AET Safety</a>
			<a mat-list-item [routerLink]="['/import']" [ngClass]="highlightImport? 'active' : '' " class="menu roboto-bold">AET Import</a>
			<a mat-list-item [routerLink]="['/reports-dashboard']" [ngClass]="highlightReports? 'active' : '' " class="menu roboto-bold">AET Reports</a>
			<a mat-list-item [routerLink]="['/kpi']" [ngClass]="highlightKPI? 'active' : '' " class="menu roboto-bold">AET KPI</a>
			<a mat-list-item [routerLink]="['/notifications']" [ngClass]="highlightNotification? 'active' : '' " class="menu roboto-bold">AET Notifications</a>
			<a mat-list-item [routerLink]="['/history']" [ngClass]="highlightHistory? 'active' : '' "		
			class="menu roboto-bold">History</a>
			
		</mat-nav-list>
	</div>


</nav>